import PropTypes from 'prop-types';

import { Button } from '@components/button/new';
import { Flex } from '@components/grid';
import { P } from '@components/typography/new';
import { Icon } from '@components/icons';

const DefaultState = ({ title, subtitle, onUndo }) => (
  <Flex
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    borderRadius="8px"
    background="white"
    height="100%"
    flex={1}
  >
    <Flex maxWidth="260px" width="100%" flexDirection="column" alignItems="center" justifyContent="center">
      <Icon name="flameSolid" fill="warmWhite3" width="50px" height="50px" mb="15px" />

      <P role="heading" variant="medium-semi-bold" aria-level="3" textAlign="center">
        {title}
      </P>
      {subtitle && (
        <P width="100%" mt="8px" textAlign="center" variant="medium">
          {subtitle}
        </P>
      )}
      {onUndo && (
        <Button width="100%" mt="24px" variant="secondary" onClick={onUndo}>
          Undo
        </Button>
      )}
    </Flex>
  </Flex>
);

DefaultState.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  onUndo: PropTypes.func,
};

DefaultState.defaultProps = {
  subtitle: null,
  onUndo: null,
};

export { DefaultState };
